import { getOpenPanel } from './openpanel';

// Page views are tracked automatically by OpenPanel (trackScreenViews),
// so these helpers only send custom events.

// Track custom events
export const trackEvent = (category, action, label = '', value = 0) => {
  try {
    getOpenPanel()?.track(`${category}: ${action}`, {
      category,
      action,
      label,
      value,
    });
  } catch (error) {
    console.error('Analytics event error:', error);
  }
};

// Track button clicks
export const trackButtonClick = (buttonName, location = '') => {
  trackEvent('Button Click', buttonName, location);
};

// Track form submissions
export const trackFormSubmission = (formName, success = true) => {
  trackEvent('Form', 'Submit', formName, success ? 1 : 0);
};

// Track external link clicks
export const trackExternalLink = (url, linkText = '') => {
  trackEvent('External Link', 'Click', `${linkText} - ${url}`);
};

// Track downloads
export const trackDownload = (fileName) => {
  trackEvent('Download', 'File', fileName);
};

// Track social media clicks
export const trackSocialClick = (platform, action = 'Click') => {
  trackEvent('Social Media', action, platform);
};

// Track project/case study views
export const trackProjectView = (projectName) => {
  trackEvent('Project', 'View', projectName);
};

// Track contact attempts
export const trackContact = (method) => {
  trackEvent('Contact', 'Attempt', method);
};

// Track errors
export const trackError = (errorMessage, location = '') => {
  trackEvent('Error', errorMessage, location);
};

const analyticsUtils = {
  trackEvent,
  trackButtonClick,
  trackFormSubmission,
  trackExternalLink,
  trackDownload,
  trackSocialClick,
  trackProjectView,
  trackContact,
  trackError,
};

export default analyticsUtils;
